import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { setInterval } from "core-js";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { getPriceValueInUsedCurrencyForCartAndExplore, getSymbolCurrency, formatPrice, roundToTwoDigit } from "@/js/currency/currencies.js";
import { fetchCategoryUser } from "@/js/user/user.js";
import { getErrorData, handleErrorData } from "@/js/forms.js";
import * as lists from "@/js/lists.ts";
export var CURRENT_ORDER = "current_order";
export var CURRENT_PAYMENT = "current_payment";
export var THIRD_PARTY_USER_SELECTED = "third_party_user_selected";
export var THIRD_PARTY_USA_PRICE_POSTING_SELECTED = "third_party_usa_price_posting_selected";
export var CART_HOURS_TIMELAPSE = 12;
export function getCountdown(time) {
  var order = getCurrentOrder();
  if (!order) return;
  CART_HOURS_TIMELAPSE = order.isCheckingWithDeposits ? 7 * 24 : 12;
  return new Date(time).getTime() + CART_HOURS_TIMELAPSE * 60 * 60 * 1000;
}
export function isCountdownElapsed(time) {
  return getCountdown(time) < new Date().getTime();
}
export function setCurrentOrder(order) {
  localStorage.setItem(CURRENT_ORDER, JSON.stringify(order));
}
export function setCurrentPayment(order) {
  localStorage.setItem(CURRENT_PAYMENT, JSON.stringify(order));
}
export function removeOrderFromStorage() {
  localStorage.removeItem(CURRENT_ORDER);
}
export function getCurrentOrder() {
  if (localStorage.getItem(CURRENT_ORDER)) {
    return JSON.parse(localStorage.getItem(CURRENT_ORDER));
  }
  return null;
}
export function removePaymentFromStorage() {
  localStorage.removeItem(CURRENT_PAYMENT);
}
export function getCurrentPayment() {
  if (localStorage.getItem(CURRENT_PAYMENT) != null && localStorage.getItem(CURRENT_PAYMENT) != "") {
    return JSON.parse(localStorage.getItem(CURRENT_PAYMENT));
  }
  return null;
}
var asyncDequeuePendingItems = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(callback) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new Promise(/*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
              var interval;
              return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            clearInterval(interval);
                            _context.next = 3;
                            return callback();
                          case 3:
                            resolve();
                          case 4:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    })), 500);
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function asyncDequeuePendingItems(_x) {
    return _ref.apply(this, arguments);
  };
}();
var managedExceptions = {
  dialogReload: {
    price_posting_expired: "DEFAULT MESSAGE IS OK + CODE TO DO TO REPLACE DEFAULT HERE"
  }
};
var itemsBuffer = [];
var creatingOrder = false;
export function addItemToCart(_x3, _x4, _x5, _x6, _x7, _x8) {
  return _addItemToCart.apply(this, arguments);
}
function _addItemToCart() {
  _addItemToCart = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(wine, quantity, casingId, toasted, _this, bypassBuyLimit) {
    var currentOrder, item, errorCatched, _getThirdPartyUserSel2, _getPricePostingUsaSe, url, hasStartedQuerySupp, thirdPartyUserId, selectedPricePostingId, _thisAfter, _yield$fetchBasket, data, _e$response3;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!creatingOrder) {
            _context4.next = 2;
            break;
          }
          return _context4.abrupt("return", asyncDequeuePendingItems(function () {
            return addItemToCart(wine, quantity, casingId, toasted, _this);
          }));
        case 2:
          // We get the current order in the local storage
          currentOrder = getCurrentOrder(); // if it does not exist, we create an empty order
          if (!currentOrder) {
            creatingOrder = true;
            currentOrder = createEmptyOrder();
          }
          _this.$EventBus.$emit("startAddingItemsToCart");

          // we look inside the items of the order to find if the item already exists
          item = currentOrder.items.filter(function (item) {
            return item.id_wine === wine.id_wine;
          })[0]; // if it doesn't, we create an empty item we add to the order
          if (!item) {
            item = createEmptyItem();
            item.id_wine = wine.id_wine;
            item.id_stock = wine.id_stock;
            item.wine = wine;
            item.id_supplier = wine.producer.id;
            item.casingId = casingId;
            currentOrder.items.push(item);
          }
          if (item.quantity == null) {
            item.quantity = parseInt(quantity);
          } else {
            item.quantity = parseInt(item.quantity) + parseInt(quantity);
            item.casingId = casingId;
          }
          item.unit_price = wine.customerPriceEuro;
          item.amount_ex_vat = (wine.customerPriceEuro * parseInt(item.quantity)).toFixed(2);
          item.total_amount = (wine.customerPriceEuro * parseInt(item.quantity)).toFixed(2);
          item.supplier_unit_price = wine.cogs_euro_ex_vat;
          item.supplier_amount_ex_vat = (wine.cogs_euro_ex_vat * parseInt(item.quantity)).toFixed(2);
          item.supplier_total_amount = (wine.cogs_euro_ex_vat * parseInt(item.quantity)).toFixed(2);
          item.unit_price_currency = getPriceValueInUsedCurrencyForCartAndExplore(item.unit_price);
          item.total_amount_currency = (item.unit_price_currency * item.quantity).toFixed(2);
          errorCatched = false;
          itemsBuffer = [].concat(_toConsumableArray(itemsBuffer), [wine.id_wine]);
          // Save the order serverside before saving it in the local storage
          _context4.prev = 18;
          if (!creatingOrder) {
            _context4.next = 34;
            break;
          }
          url = "/v1/order";
          hasStartedQuerySupp = false;
          thirdPartyUserId = (_getThirdPartyUserSel2 = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel2 === void 0 ? void 0 : _getThirdPartyUserSel2.id_user;
          if (thirdPartyUserId) {
            url += "".concat(hasStartedQuerySupp ? "&" : "?", "thirdPartyUserId=").concat(thirdPartyUserId);
            hasStartedQuerySupp = true;
          }
          url += "".concat(hasStartedQuerySupp ? "&" : "?", "isApplyActivePricePostingByDefault=false");
          hasStartedQuerySupp = true;
          selectedPricePostingId = (_getPricePostingUsaSe = getPricePostingUsaSelected()) === null || _getPricePostingUsaSe === void 0 ? void 0 : _getPricePostingUsaSe.id;
          if (selectedPricePostingId !== null && selectedPricePostingId !== undefined) {
            url += "".concat(hasStartedQuerySupp ? "&" : "?", "pricePostingUsaProId=").concat(selectedPricePostingId);
            hasStartedQuerySupp = true;
          }
          if (bypassBuyLimit) {
            url += "".concat(hasStartedQuerySupp ? "&" : "?", "bypassBuyLimits=").concat(bypassBuyLimit);
            hasStartedQuerySupp = true;
          }
          _thisAfter = _this;
          _context4.next = 32;
          return request(url, "post", currentOrder, true, "api").catch(function (e) {
            var _e$response;
            var _e$response$data$valu = e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.value,
              message = _e$response$data$valu.message,
              errorCode = _e$response$data$valu.errorCode;
            if (errorCode in managedExceptions.dialogReload) {
              errorCatched = true;
              var errorData = getErrorData(e, managedExceptions, null, false);
              handleErrorData(_thisAfter, errorData);
            } else if (message) {
              itemsBuffer = _toConsumableArray(itemsBuffer.filter(function (x) {
                return x !== wine.id_wine;
              }));
              errorCatched = true;
              toasted.show(message, {
                type: "warning"
              });
              _this.$EventBus.$emit("noMoreItemsToAddToCart");
            }
            throw e;
          });
        case 32:
          _context4.next = 41;
          break;
        case 34:
          if (!item.id_item) {
            _context4.next = 39;
            break;
          }
          _context4.next = 37;
          return changeQuantity(currentOrder.id_order, item.id_item, item.quantity, item.casingId, toasted);
        case 37:
          _context4.next = 41;
          break;
        case 39:
          _context4.next = 41;
          return request("/v1/basket/items", "post", {
            id_order: currentOrder.id_order,
            id_wine: wine.id_wine,
            id_stock: wine.id_stock,
            quantity: item.quantity,
            casingId: item.casingId
          }, true, "api").catch(function (e) {
            var _e$response2;
            var _e$response$data = e === null || e === void 0 || (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : _e$response2.data,
              value = _e$response$data.value;
            if (value) {
              var _value$errorMessage;
              itemsBuffer = _toConsumableArray(itemsBuffer.filter(function (x) {
                return x !== wine.id_wine;
              }));
              errorCatched = true;
              var message = (_value$errorMessage = value.errorMessage) !== null && _value$errorMessage !== void 0 ? _value$errorMessage : value.message;
              toasted.show(message, {
                type: "warning"
              });
              _this.$EventBus.$emit("noMoreItemsToAddToCart");
            }
            throw e;
          });
        case 41:
          itemsBuffer = _toConsumableArray(itemsBuffer.filter(function (x) {
            return x !== wine.id_wine;
          }));
          _context4.next = 44;
          return fetchBasket();
        case 44:
          _yield$fetchBasket = _context4.sent;
          data = _yield$fetchBasket.data;
          if (data) {
            setCurrentOrder(data);
          }
          refreshCategoryUser(_this);
          creatingOrder = false;
          if (!itemsBuffer.length) {
            _this.$EventBus.$emit("add-item-to-cart");
            _this.$EventBus.$emit("loading", false);
            toasted.show("Item added to your cart.", {
              type: "success"
            });
            _this.$EventBus.$emit("noMoreItemsToAddToCart");
          }
          _context4.next = 57;
          break;
        case 52:
          _context4.prev = 52;
          _context4.t0 = _context4["catch"](18);
          creatingOrder = false;
          if (!axios.isCancel(_context4.t0) && !errorCatched) {
            toasted.show("An error occured. Please contact an administrator.", {
              type: "error"
            });
            _this.$EventBus.$emit("loading", false);
            _this.$EventBus.$emit("noMoreItemsToAddToCart");
          }
          throw _context4.t0 === null || _context4.t0 === void 0 || (_e$response3 = _context4.t0.response) === null || _e$response3 === void 0 ? void 0 : _e$response3.data;
        case 57:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[18, 52]]);
  }));
  return _addItemToCart.apply(this, arguments);
}
var isFetching = false;
var cancelTokenSource = null;
export function fetchBasket() {
  if (!isFetching) {
    var _getThirdPartyUserSel;
    cancelTokenSource = axios.CancelToken.source();
    isFetching = true;
    var url = "/v1/basket";
    var thirdPartyUserId = (_getThirdPartyUserSel = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel === void 0 ? void 0 : _getThirdPartyUserSel.id_user;
    if (thirdPartyUserId) url += "?thirdPartyUserId=".concat(thirdPartyUserId);
    return request(url, "get", null, true, "api", null, cancelTokenSource).then(function (data) {
      isFetching = false;
      return data;
    });
  } else {
    cancelTokenSource.cancel();
    isFetching = false;
    return fetchBasket();
  }
}

//to be tested
export function emptyBasket() {
  var _this2 = this;
  var orderId = getCurrentOrder().id_order;
  var _this = this;
  return request("/v1/basket/" + orderId, "delete", {
    orderId: orderId
  }, true, "api").then(function () {
    removeOrderFromStorage();
    refreshCategoryUser();
    _this2.$EventBus.$emit("BasketRemoved");
    _this2.$EventBus.$emit("ItemRemoved", {
      detail: {
        items: []
      }
    });
  }).catch(function (e) {
    var errorData = getErrorData(e, {}, "Unable to empty cart.");
    handleErrorData(_this, errorData);
    throw e;
  });
}
export function changeQuantity(orderId, itemId, quantity, casingId, toasted) {
  return request("/v1/basket/items/".concat(itemId, "/quantity"), "post", {
    orderId: orderId,
    quantity: quantity,
    casingId: casingId
  }, true, "api").catch(function (e) {
    var value = e.response.data.value;
    if (value) toasted.show(value.errorMessage, {
      type: "warning"
    });
    throw e;
  });
}
export function refreshCategoryUser(_x9) {
  return _refreshCategoryUser.apply(this, arguments);
}
function _refreshCategoryUser() {
  _refreshCategoryUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_this) {
    var _getThirdPartyUserSel3;
    var currentOrder, thirdPartyUserSelected, categoryUser;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          currentOrder = getCurrentOrder();
          thirdPartyUserSelected = (_getThirdPartyUserSel3 = getThirdPartyUserSelected()) === null || _getThirdPartyUserSel3 === void 0 ? void 0 : _getThirdPartyUserSel3.id_user;
          _context5.next = 4;
          return fetchCategoryUser(thirdPartyUserSelected, currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id_order);
        case 4:
          categoryUser = _context5.sent;
          _this.$EventBus.$emit("refresh_category_user", categoryUser);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _refreshCategoryUser.apply(this, arguments);
}
export function createEmptyOrder() {
  return {
    id_order: null,
    items: [],
    id_user: null,
    amount_ex_vat: null,
    total_amount: null,
    supplier_amount_ex_vat: null,
    supplier_total_amount: null,
    status: lists.orderStatus.filter(function (os) {
      return os.id === "CREATED";
    })[0].status,
    expedition_method: 0,
    id_delivery_address: null,
    id_billing_address: null,
    id_carrier: null,
    reference_order: null,
    amount_taxes: 0,
    amount_shipping: 0,
    due_date: null,
    buyer_term: 0,
    cancellation_date: null,
    deleted: false
  };
}
export function createEmptyItem() {
  return {
    id_item: null,
    id_order: null,
    id_wine: null,
    wine: null,
    unit_price: 0,
    crd: false,
    status: lists.itemStatus.filter(function (os) {
      return os.id === "CREATED";
    })[0].status,
    quantity: 0,
    id_supplier: null,
    total_amount: 0,
    amount_ex_vat: 0,
    supplier_unit_price: 0,
    supplier_total_amount: 0,
    supplier_amount_ex_vat: 0,
    amount_taxes: 0,
    deleted: false
  };
}
export function getThirdPartyUserSelected() {
  if (!hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER)) {
    localStorage.removeItem(THIRD_PARTY_USER_SELECTED);
    return null;
  } else {
    return JSON.parse(localStorage.getItem(THIRD_PARTY_USER_SELECTED));
  }
}
export function setThirdPartyUserSelected(value) {
  if (!hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER)) {
    localStorage.removeItem(THIRD_PARTY_USER_SELECTED);
  } else {
    localStorage.setItem(THIRD_PARTY_USER_SELECTED, JSON.stringify(value));
  }
}
export function changeOrderPricePosting(id, orderId) {
  var _this = this;
  var data = {
    pricePostingUsaProId: id
  };
  return request("/v1/orders/".concat(+orderId, "/price-posting"), "put", data, true, "api", null).catch(function (e) {
    var errorData = getErrorData(e, {}, "Unable to change price posting");
    _this.$toasted.show(errorData.message, {
      type: errorData.type
    });
    throw e;
  });
}
export function getPricePostingUsaSelected() {
  var value = localStorage.getItem(THIRD_PARTY_USA_PRICE_POSTING_SELECTED);
  return value !== undefined ? JSON.parse(value) : null;
}
export function setPricePostingUsaSelected(value) {
  localStorage.setItem(THIRD_PARTY_USA_PRICE_POSTING_SELECTED, JSON.stringify(value));
}
export function removePricePostingUsaLocale() {
  localStorage.removeItem(THIRD_PARTY_USA_PRICE_POSTING_SELECTED);
}
export function getOrderConfirmationReference(order) {
  var dateOrder = new Date(order.date_order);
  var formattedDate = "".concat(dateOrder.getFullYear().toString().slice(-2));
  var formattedId = order.id_order.toString().padStart(9, "0");
  return "OC-".concat(formattedDate).concat(formattedId);
}
export function calculateOrderAmountsLocal(order) {
  if (!order.isFullyCalculatedAmounts) {
    if (order.items) {
      var orderTaxAmount = 0;
      var orderTaxAmountCurrency = 0;
      var orderVatAmount = 0;
      var orderVatAmountCurrency = 0;
      var orderAmountExVat = 0;
      var orderAmountExVatCurrency = 0;
      var orderTotalAmount = 0;
      var orderTotalAmountCurrency = 0;
      var orderSupplierAmountExVat = 0;
      var orderSupplierTotalAmount = 0;
      order.items.forEach(function (x) {
        orderTaxAmount += x.amount_taxes;
        orderTaxAmountCurrency += x.amount_taxes_currency;
        orderVatAmount += x.total_amount - x.amount_ex_vat;
        orderVatAmountCurrency += x.total_amount_currency - x.amount_ex_vat_currency;
        orderAmountExVat += x.amount_ex_vat;
        orderAmountExVatCurrency += x.amount_ex_vat_currency;
        orderTotalAmount += x.total_amount;
        orderTotalAmountCurrency += x.total_amount_currency;
        orderSupplierAmountExVat += x.supplier_amount_ex_vat;
        orderSupplierTotalAmount += x.supplier_total_amount;
        order.handlingAmount += x.handling_amount;
        order.handlingAmountCurrency += x.handling_amount_currency;
      });
      order.credit_notes_amount = 0;
      order.credit_notes_amount_currency = 0;
      order.credit_notes_amount_ex_vat = 0;
      order.credit_notes_amount_ex_vat_currency = 0;
      if (order.credit_notes) {
        order.credit_notes.forEach(function (x) {
          order.credit_notes_amount += x.amountEuro;
          order.credit_notes_amount_currency += x.amountCurrency;
          order.credit_notes_amount_ex_vat += x.amountExVatEuro;
          order.credit_notes_amount_ex_vat_currency += x.amountExVatCurrency;
        });
      }
      var shippingVat = order.amount_shipping - order.amountShippingExVat;
      var shippingVatCurrency = order.amount_shipping_currency - order.amountShippingExVatCurrency;
      order.amount_taxes = orderTaxAmount;
      order.amount_taxes_currency = orderTaxAmountCurrency;
      order.supplier_amount_ex_vat = orderSupplierAmountExVat;
      order.supplier_total_amount = orderSupplierTotalAmount;
      order.total_amount = orderTotalAmount + order.amount_shipping;
      order.total_amount_currency = orderTotalAmountCurrency + order.amount_shipping_currency;
      order.total_amount_include_credit_notes = order.total_amount - order.credit_notes_amount;
      order.total_amount_currency_include_credit_notes = order.total_amount_currency - order.credit_notes_amount_currency;
    }
  }
  return order;
}
export function getUnitPriceCurrencyForItem(item, orderExpMethod) {
  return orderExpMethod === lists.expeditionMethods.CELLAR_STORAGE.id ? item.unit_price_currency : item.unitPriceIncludeDefaultShippingCurrency;
}
export function showShippingPriceMinusDefault(shipItem, orderItems, orderCurrency) {
  var nbBottles = orderItems === null || orderItems === void 0 ? void 0 : orderItems.reduce(function (acc, item) {
    return acc + item.quantity;
  }, 0);
  var defaultIncludedCurrency = roundToTwoDigit(orderItems.reduce(function (acc, item) {
    return acc + item.unitDefaultShippingCurrency * item.quantity;
  }, 0));
  var price = roundToTwoDigit(shipItem.expeditionPriceCurrency - defaultIncludedCurrency);
  var absolutePrice = Math.abs(price);
  var html = "";
  if (price > 0) {
    html += "<div>+".concat(formatPrice(price / nbBottles), " ").concat(getSymbolCurrency(orderCurrency), " /bottle<div>");
  } else if (price < 0 && absolutePrice > nbBottles / 100) {
    html += "<div>Bonus -".concat(formatPrice(absolutePrice / nbBottles), " ").concat(getSymbolCurrency(orderCurrency), " /bottle<div>");
  } else {
    html += "<div>Free</div>";
  }
  return html;
}

//Copied from BackAPI:LogisticQueryHandler.GetNbRegularBottlePerBottlingForLogisticCost
export function getNbRegularBottlePerBottlingForLogisticCost(bottling) {
  if (bottling === 375) {
    return 0.5;
  } else if (bottling === 500 || bottling === 750 || bottling === 700) {
    return 1;
  } else if (bottling === 1500) {
    return 2;
  } else if (bottling === 3000) {
    return 4;
  } else if (bottling === 4500) {
    return 6;
  } else if (bottling === 5000) {
    return 7;
  } else if (bottling === 6000) {
    return 8;
  } else {
    return 1;
  }
}